import { useApiQuery } from 'src/api';
import { useBuildVars } from 'src/config';

export interface ProductGroupList {
  productGroupId: number;
  productGroupName: string;
}
export interface CustomerGroupList {
  customer_group_id: number;
  customergroupname: string;
}
export interface IngramProgram {
  activeDiscount: number;
  customer_group_list: CustomerGroupList[];
  ingramProgramId: number;
  ingramProgramName: string;
  lastChangeDate: string;
  product_group_list: ProductGroupList[];
  programType: string;
}
export interface IngramProgramResponse {
  ingramProgramList: IngramProgram[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}
export interface IngramProgramRequest {
  IngramProgramName?: string;
  page: number;
  pageSize: number;
}

export function useGetIngramPrograms(params: IngramProgramRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<IngramProgramResponse>(
    '/system.webapi.gds/api/v1/GdsCoreApiIngramProgram/GetIngramVendorPrograms',
    params,
    undefined,
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export interface IngramProgramDetailResponse {
  ingramVendorProgramDetail: {
    manualTemplatesFieldProperties: {
      vendorACOPDiscountType: string;
    };
    requestPreamble: {
      createdBy: string;
      createdDate: string;
      customerGroupInfo: CustomerGroupList[];
      ingramProgramName: string;
      ingramVendorProgramId: number;
      lastChangeUser: string;
      lastChangedDate: string;
      productGroupInfo: ProductGroupList[];
      programsDescription: string;
    };
  };
}

export function useGetIngramProgramDetails(IngramVendorProgramId: number) {
  const buildVars = useBuildVars();
  return useApiQuery<IngramProgramDetailResponse>(
    '/system.webapi.gds/api/v1/GdsCoreApiIngramProgram/EditIngramProgram',
    { IngramVendorProgramId },
    { enabled: !!IngramVendorProgramId },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
export interface IngramDiscount {
  applicability: Applicability[];
  discountAmount: number;
  discountCalcType: string;
  discountType: string;
  effectiveDate: string;
  expirationDate: string;
  id: number;
  lastUpdated: string;
  name: string;
  programId: number;
  statusCode: string;
  updatedBy: string;
}
export interface IngramDiscountResponse {
  data: IngramDiscount[];
  responsePreamble: {
    currentPage: number;
    hasNext: boolean;
    hasPrevious: boolean;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
}

export interface IngramDiscountRequest {
  discountName?: string;
  ingramProgramId: number;
  page: number;
  pageSize: number;
}

export function useGetIngramDiscounts(params: IngramDiscountRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<IngramDiscountResponse>(
    '/system.webapi.gds/api/v1/GdsCoreApiIngramDiscounts/GetIngramDiscount',
    params,
    { enabled: !!params.ingramProgramId },
    undefined,
    { host: buildVars.VP_API_BASE }
  );
}

export interface Applicability {
  attributename: string;
  attributevalue: string;
}

export interface IngramDiscountById {
  applicability: Applicability[];
  country_code: string;
  description: string;
  discount_amount: string;
  discount_calc_type: string;
  discount_type: string;
  effective_date: string;
  expiration_date: string;
  id: number;
  name: string;
  program_id: number;
  sk_company: number;
  status_code: string;
}

export function useGetIngramDiscountById(id?: number) {
  const buildVars = useBuildVars();
  return useApiQuery<IngramDiscountById>(
    '/system.webapi.gds/api/v1/GdsCoreApiIngramDiscounts/GetIngramDiscountById',
    { id },
    { enabled: !!id },
    undefined,
    { host: buildVars.VP_API_BASE }
  );
}
